<template>
  <div class="container">
    <top-menu :current="['dealer']"></top-menu>

    <div class="main-container">
      <div class="dealer-filter">
        <div class="cate">
          <a-dropdown style="text-align: center">
            <a class="ant-dropdown-link" @click="showBrands()">
              {{ cur_brand }} <a-icon type="down" />
            </a>
          </a-dropdown>
        </div>
      </div>
      <div class="dealers">
        <ul class="areaJxs">
          <li class="flexBC" v-for="item in dealers" v-bind:key="item.id">
            <div class="logo">
              <img :src="item.img_url" />
            </div>
            <div class="name text">
              <h3 class="f30 dealer__name mb-10">{{ item.name }}</h3>
              <div class="dealer__brand">主营品牌：{{ item.sale_brands }}</div>
              <div class="dealer__address">地址：{{ item.address }}</div>
            </div>
            <div class="quote-btn">
              <p>询价</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="new-more" @click="more" v-if="!is_end">加载更多</div>
      <div class="new-more" v-if="is_end">数据已全部加载</div>
    </div>

    <a-drawer
      title="选择品牌"
      placement="right"
      :closable="true"
      :visible="brandVisible"
      :after-visible-change="afterVisibleChange"
      @close="onClose"
      :bodyStyle="{ padding: 0 }"
    >
      <div class="quote-brand-card" v-for="item in brands" :key="item.letter">
        <div class="quote-brand-card__letter">{{ item.letter }}</div>
        <ul>
          <li
            v-for="ite in item.brands"
            :key="ite.id"
            @click="chooseBrand(ite)"
          >
            <img :src="ite.logo_url" />
            <span> {{ ite.name }}</span>
          </li>
        </ul>
      </div>
    </a-drawer>

    <Footer />
  </div>
</template>

<script>
import TopMenu from "@/components/Menu";
import Footer from "@/components/Footer";
import brandData from "@/data/brand";
import { getDealers } from "@/api/dealer";

export default {
  name: "Index",
  components: {
    TopMenu,
    Footer,
  },
  data() {
    return {
      page: 1,
      limit: 20,
      brandVisible: false,
      brands: [],
      cur_brand: "全部品牌",
      dealers: [],
      total: 0,
      selected: {
        brand_ids: [],
      },
      is_end: false
    };
  },
  computed: {},
  beforeCreadted() {},
  created() {
    this.initData();
    this.getData();
  },
  beforeDestroy() {},
  methods: {
    getData() {
      console.log('sss----', this.selected)
      getDealers({
        brand_ids: this.selected.brand_ids,
        cid: this.getCityId(),
        page: this.page,
        limit: this.limit,
      }).then((resp) => {
        // this.dealers = resp.data.list;
        this.total = resp.data.total;
        if (resp.data.length < this.limit) {
          this.is_end = true;
        }

        var that = this

        resp.data.list.forEach(respss => {
            that.dealers.push(respss);
        });
      });
    },
    initData() {
      let letters = []; // 数据列表
      let brandMap = {}; // 每一个索引指向一个数组，这个数组存储该字母索引的朋友项

      brandData.forEach((brand) => {
        const letter = brand.letter;
        brandMap[letter] || (brandMap[letter] = []);
        brandMap[letter].push(brand);
      });

      for (let letter in brandMap) {
        letters.push({
          letter: letter,
          brands: brandMap[letter],
        });
      }

      // 按首字母排序
      // 字符串比较不能用减号得出大小，返回都是NaN
      // 因此这里需要通过小于号比较
      letters.sort((a, b) => {
        return a.letter <= b.letter ? -1 : 1;
      });

      this.brands = letters;
    },
    onClose() {
      this.brandVisible = false;
    },
    showBrands() {
      this.brandVisible = true;
    },
    afterVisibleChange() {},
    chooseBrand(brand) {
      console.log(brand);
      this.cur_brand = brand.name;
      this.brandVisible = false;
      this.selected.brand_ids = [brand.id]
      this.dealers = []
      this.getData()
    },
    getCityId() {
      let curCity = localStorage.getItem("_m_cur_city");

      console.log("ssss", curCity);

      if (curCity) {
        console.log(">>>", curCity);
        let curCityData = JSON.parse(curCity);

        return curCityData.c_id;
      }

      return 110100;
    },

    more() {
      this.page = this.page + 1;
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 800px;
  // overflow: hidden;
  margin: 0 auto;
}
.main-container {
  // margin: 0.8rem;
   position: relative;
  top:100px;
}
.quote-brand-card {
  .quote-brand-card__letter {
    position: relative;
    height: 1.5rem;
    margin: 0;
    padding: 0 0 0 0.5rem;
    font-size: 0.65rem;
    color: #333;
    line-height: 1.5rem;
    background-color: #f8f8f8;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    overflow: hidden;
    li {
      position: relative;
      padding: 0.25rem 0 0.25rem 0.5rem;
      img {
        float: left;
        width: 2.5rem;
        height: 2.5rem;
        margin: 0;
      }
      & > span {
        position: relative;
        display: block;
        height: 2.5rem;
        padding: 0;
        margin: 0 0 0 3.5rem;
        font-size: 0.8rem;
        color: #333;
        line-height: 2.5rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
.dealer-filter {
  width: 100%;
  height: 38px;
  background-color: #fff;
  margin: 10px 0px 20px;
  display: flex;
  line-height: 38px;
  .cate {
    display: flex;
    background: #f9f9f9;
    flex: 1;
    border-right: 1px solid #eff3f8;
    cursor: pointer;
    justify-content: center;

    a {
      color: #333;
    }

    & > div {
      font-size: 14px;
      font-weight: 700;
      color: #616b84;
      line-height: 20px;
      padding: 10px 0;

      width: 100%;
      text-align: center;
    }
    .pl-sub-cate {
      margin-bottom: 16px;
      font-size: 14px;
      font-weight: 700;
      color: #616b84;
      cursor: pointer;
    }
  }
  .cate__selected {
    background-color: #fe815f;
    color: #fff !important;
  }
}
.new-more {
    text-align: center;
    margin: 10px 0 15px;
  }
.dealers {
  ul {
    list-style: none;
    background: #fff;
  }
  ul.areaJxs {
    li {
      padding: 0.4rem;
      border-bottom: 0.015rem solid #dedede;
      .logo {
        margin-right: 10px;
        img {
          width: 72px;
          height: 72px;
        }
      }

      .text {
        flex: 1;
        margin-left: 0.1rem;
      }

      .dealer__name {
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin-bottom: 5px;
      }
      .dealer__brand {
        margin-bottom: 5px;
      }
      .dealer__address {
        margin-bottom: 5px;
         text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .quote-btn {
        background: #ff4b3c;
        color: #fff;
        height: 36px;
        overflow: hidden;
        line-height: 36px;
        border-radius: 5px;
        margin: 10px 0px;
        text-align: center;
        padding: 0px 10px;
        margin-left: 5px;
      }
    }
  }
}

.flexBC {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>

